import React from "react";
import Aux from "../../../../hoc/Auxillary";
import Logo from "../../../Logo/Logo";
import Backdrop from "../../../UI/Backdrop/Backdrop";
import NavigationItems from "../NavigationItems/NavigationItems";
import "./Sidedrawer.scss";

const Sidedrawer = (props) => {
    let attachedClasses = "Sidedrawer Closed";
    if (props.open) {
        attachedClasses = "Sidedrawer Open";
    }
  return (
    <Aux>
      <Backdrop show={props.open} clicked={props.closed} />
      <div className={attachedClasses}>
        <div className="logo-wrapper">
          <Logo />
        </div>
        <nav>
          <NavigationItems
            activeLink="Burger Builder"
            isAuth={props.isAuth}
            closed={props.closed}
          />
        </nav>
      </div>
    </Aux>
  );
};

export default Sidedrawer;
